import spin from "./images/spin.gif";
import default_course_image from "./images/default_image.webp"
import close_sidebar from "./images/close_sidebar.svg";
import open_sidebar from "./images/open_sidebar.svg";
import download from "./images/download.svg";
import quiz_bg from "./images/quiz_bg.svg";
import quiz_indicator from "./images/quiz.avif";
import page_not_found from "./images/404.gif";
import verified_tick from "./images/verified.svg";
import unverified_exclaim from "./images/unverified.svg";
import default_iitb_image from "./images/default_iitb_image.webp";
import upload_image from "./images/upload_image.webp";
import down_arrow from "./images/down_arrow.svg";
import up_arrow from "./images/up_arrow.svg";
import saving_loader from "./images/saving.gif";

import dummy_profile_picture from "./images/fourth.webp";

const showMoreArrow = <svg enableBackground="new 0 0 26 26" height="10px"version="1.1" viewBox="0 0 26 26" width="10px" xmlns="http://www.w3.org/2000/svg">
    <g>
        <polygon fill="#007BFF" points="0.046,2.582 2.13,0.498 12.967,11.334 23.803,0.498 25.887,2.582 12.967,15.502  "/>
        <polygon fill="#007BFF" points="0.046,13.582 2.13,11.498 12.967,22.334 23.803,11.498 25.887,13.582 12.967,26.502  "/>
    </g>
</svg>;

export {
    spin,
    default_course_image,
    close_sidebar,
    open_sidebar,
    download,
    quiz_bg,
    quiz_indicator,
    page_not_found,
    verified_tick,
    unverified_exclaim,
    default_iitb_image,
    upload_image,
    dummy_profile_picture,
    showMoreArrow,
    down_arrow,
    up_arrow,
    saving_loader
};
